import camelcaseKeys from "camelcase-keys";
import { saveAs } from "file-saver";
import {
  getCustomerPage,
  getCustomerPageAllSearchKey,
  onAddCustomersToBroadcastList,
  onCreateCustomer,
  onDeleteCustomer,
  onExportCSVCustomers,
  onGetAllCustomerNotInBroadcastList,
  onGetAllCustomers,
  onGetCustomerDetail,
  onUpdateCustomer,
  onUpdateOptInCustomer,
} from "services/apis/customer";
import snakeCaseKeys from "snakecase-keys";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetCustomerPage = createAsyncThunk(
  "customer/doGetCustomerPage",
  async (params, { dispatch }) => {
    const request = snakeCaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k]
                .trim()
                .replaceAll(/&/g, "&amp;")
                .replaceAll(/>/g, "&gt;")
                .replaceAll(/</g, "&lt;")
                .replaceAll(/"/g, '"')
                .replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await getCustomerPage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    dispatch(setPageNumber(result.pageNumber));
    dispatch(setTotalPages(result.totalPages));
    return camelcaseKeys(result);
  }
);

export const doGetCustomerPageSearchKeyAll = createAsyncThunk(
  "customer/doGetCustomerPageSearchKeyAll",
  async (params, { dispatch }) => {
    const request = snakeCaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k]
                .trim()
                .replaceAll(/&/g, "&amp;")
                .replaceAll(/>/g, "&gt;")
                .replaceAll(/</g, "&lt;")
                .replaceAll(/"/g, '"')
                .replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await getCustomerPageAllSearchKey(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return camelcaseKeys(result);
  }
);

export const doCreateCustomer = createAsyncThunk(
  "customer/doCreateCustomer",
  async params => {
    const result = await onCreateCustomer(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doAddCusomtersToBroadcastList = createAsyncThunk(
  "customer/doAddCusomtersToBroadcastList",
  async params => {
    const result = await onAddCustomersToBroadcastList(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doUpdateCustomer = createAsyncThunk(
  "customer/doUpdateCustomer",
  async params => {
    const result = await onUpdateCustomer(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteCustomer = createAsyncThunk(
  "customer/doDeleteCustomer",
  async params => {
    const result = await onDeleteCustomer(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetCustomerDetail = createAsyncThunk(
  "customer/doGetCustomerDetail",
  async params => {
    const result = await onGetCustomerDetail(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doExportCSVCustomersByBroadcastList = createAsyncThunk(
  "customer/doExportCSVCustomersByBroadcastList",
  async params => {
    const result = await onExportCSVCustomers({
      id: params.id,
      workspaceId: params.workspaceId,
    });
    if (!result) {
      return;
    }
    const blob = new Blob(["\ufeff", result], {
      type: "text/csv;charset=utf-8",
    });
    saveAs(blob, params.fileName);
    return result;
  }
);

export const doGetAllCustomers = createAsyncThunk(
  "customer/doGetAllCustomers",
  async () => {
    const result = await onGetAllCustomers();
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetAllCustomerNotInBroadcastList = createAsyncThunk(
  "customer/doGetAllCustomerNotInBroadcastList",
  async params => {
    const request = snakeCaseKeys(params);
    const result = await onGetAllCustomerNotInBroadcastList(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doUpdateOptInCustomer = createAsyncThunk(
  "customer/doUpdateOptInCustomer",
  async params => {
    const request = snakeCaseKeys(params);
    const result = await onUpdateOptInCustomer(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

const initialState = {
  isSaving: false,
  customerDetail: {},
  list: [],
  allCustomers: [],
  listAll: [],
  queries: {
    pageNumber: 1,
    pageSize: 20,
    totalPages: 0,
  },
  pageNumber: 1,
  totalPages: 1,
};

const slice = createSlice({
  name: "customer",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
  extraReducers: {
    [doGetCustomerPage.pending]: state => {
      state.isSaving = true;
    },
    [doGetCustomerPage.fulfilled]: (state, action) => {
      state.isSaving = false;
      state.list = action.payload.content || [];
    },
    [doGetCustomerPage.rejected]: state => {
      state.isSaving = false;
    },
    [doCreateCustomer.pending]: state => {
      state.isSaving = true;
    },
    [doCreateCustomer.fulfilled]: state => {
      state.isSaving = false;
    },
    [doCreateCustomer.rejected]: state => {
      state.isSaving = false;
    },
    [doUpdateCustomer.pending]: state => {
      state.isSaving = true;
    },
    [doUpdateCustomer.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUpdateCustomer.rejected]: state => {
      state.isSaving = false;
    },
    [doGetCustomerDetail.fulfilled]: (state, action) => {
      state.customerDetail = action.payload.data;
    },
    [doGetAllCustomers.fulfilled]: (state, action) => {
      state.allCustomers = action.payload;
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements, setPageNumber, setTotalPages } = actions;

export const { setOptList } = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.customer.isSaving,
  isSaving => isSaving
);

export const fecthCustomerDetail = createSelector(
  state => state.customer.customerDetail,
  customerDetail => customerDetail
);

export const fetchListCusomter = createSelector(
  state => state.customer.list,
  list => list
);

export const numOfEls = createSelector(
  state => state.customer.numberOfElements,
  numberOfElements => numberOfElements
);

export const fetchAllCustomers = createSelector(
  state => state.customer.allCustomers,
  allCustomers => allCustomers
);

export const fetchAllCustomersNotInBroadcastList = createSelector(
  state => state.customer.listAll,
  listAll => listAll
);
export const fetchQueries = createSelector(
  state => state.customer.queries,
  queries => queries
);

export const pageNumber = createSelector(
  state => state.customer.pageNumber,
  pageNumber => pageNumber
);

export const totalPages = createSelector(
  state => state.customer.totalPages,
  totalPages => totalPages
);
